import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, CustomInput, CustomSelect, Modal, NoResult, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import {
  SESSION_RESULT_EXPORT,
  SESSION_RESULT_GET,
} from '../../../../app/redux/actions/liveEvent';
import SortBy from '../../SortBy';
import Pagination from '../../Pagination';
import {
  ButtonWrapper,
  CardsWrapper,
  FiltersContainer,
  FixedContainer,
  Legend,
  LegendAndCard,
  Sorting,
  UserCard,
} from './style';
import { timestampToDate } from '../../../../utils/common';
import {
  getFilterLabel,
  getFilterOptions,
  getSortingOptions,
} from '../../../../utils/labels';
import { EVENT_USER_SORT_OPTS } from '../../../../app/pages/LiveEventDetails/SessionBlock';

export const ModalSessionResultsId = 'ModalSessionResults';

const ModalSessionResults = ({
  mediaIsPhone,
  payload,
  list,
  filters,
  pager,
  modalClose,
  getSessionResult,
  exportSessionResult,
}) => {
  const scrollableAreaRef = useRef(null);
  // filters
  const [sessionId, setSessionId] = useState();
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();

  const [showFilters, setShowFilters] = useState(true);
  useEffect(() => {
    setShowFilters(!mediaIsPhone);
  }, [mediaIsPhone]);

  const handleGetSessionResult = (page) => {
    if (sessionId) getSessionResult(sessionId, { ...selectedFilters, page });
  };

  useEffect(() => {
    if (payload?.sessionId) {
      setSessionId(payload.sessionId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload]);

  useEffect(() => {
    if (payload?.sessionId) {
      setSessionId(payload.sessionId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload]);

  useEffect(() => {
    handleGetSessionResult();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId, selectedFilters]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handleGetSessionResult(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <Modal
      title="Risultati sessione"
      mbTitle={8}
      subTitle={`Sessione ${payload?.sessionName ? `“${payload?.sessionName}” ` : ''
        }${payload?.sessionNumber}`}
      mbSubTitle={8}
      description="Sezione dedicata a visualizzare i risultati della sessione completata."
      modalId={ModalSessionResultsId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ButtonWrapper>
        <CTA
          type="tertiary"
          btnText="Esporta csv"
          icon="download-01"
          onClick={() => exportSessionResult(sessionId)}
        />
      </ButtonWrapper>
      <FixedContainer>
        <FiltersContainer>
          <CustomInput
            size={mediaIsPhone ? 's' : 'l'}
            placeholder="Cosa vuoi cercare?..."
            isSearch
            value=""
            icon="search-sm"
            isClearable
            onChange={(v) => setSearchValue(v)}
            onClickIcon={onClickSearch}
            onKeyPress={(event) => {
              if (event.key === 'Enter') onClickSearch();
            }}
          />
          {mediaIsPhone && (
            <CTA
              type="secondary"
              btnText={showFilters ? 'Nascondi' : 'Filtri'}
              onClick={() => setShowFilters(!showFilters)}
            />
          )}
          {showFilters && (
            <>
              {/* //? it's not "Edizione" as in figma, but "Titolo attività" */}
              {(Object.keys(filters) || []).map(
                (key, i) =>
                  filters[key]?.length > 1 && (
                    <CustomSelect
                      size={mediaIsPhone ? 'full' : 's'}
                      wrapperId={`filter-${key}`}
                      key={`filter-${i}`}
                      placeholder={getFilterLabel(key)}
                      options={getFilterOptions(filters, key)}
                      onChange={(value) => handleOnChange({ key, value })}
                      isClearable
                    />
                  )
              )}
              {mediaIsPhone && (
                <SortBy
                  options={getSortingOptions(EVENT_USER_SORT_OPTS)}
                  onChange={(v) => {
                    setSelectedFilters({
                      ...selectedFilters,
                      sort_by: v?.value,
                    });
                  }}
                />
              )}
            </>
          )}
        </FiltersContainer>
        {mediaIsPhone ? (
          <Text type="b3" mb={24}>
            {pager?.total_items || 0} utenti presenti
          </Text>
        ) : (
          <>
            <Sorting className="d-flex sb g-24">
              <Text type="b3">{pager?.total_items || 0} utenti presenti</Text>
              <SortBy
                options={getSortingOptions(EVENT_USER_SORT_OPTS)}
                onChange={(v) => {
                  setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
                }}
              />
            </Sorting>
            <LegendAndCard
              gridTemplateColumns="repeat(7, 1fr)"
              gridTemplateRows="repeat(7, 1fr)"
            >
              <Legend>
                <Text type="statistics-heading">Nome</Text>
                <Text type="statistics-heading">Titolo attività</Text>
                <Text type="statistics-heading">Presenza</Text>
                <Text type="statistics-heading">Stato Quiz</Text>
                <Text type="statistics-heading">Punteggio</Text>
                <Text type="statistics-heading">Data e ora inzio quiz</Text>
                <Text type="statistics-heading">Data e ora fine quiz</Text>
              </Legend>
            </LegendAndCard>
          </>
        )}
      </FixedContainer>
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{ minHeight: '40vh' }}
        preserveShadows
      >
        {list.length > 0 ? (
          <CardsWrapper hasPaginator={pager?.number_of_pages > 1}>
            {(list || []).map((user, i) => (
              <LegendAndCard
                key={`user-${i}`}
                gridTemplateColumns="repeat(7, 1fr)"
                gridTemplateRows="repeat(7, 1fr)"
              >
                {mediaIsPhone && (
                  <Legend>
                    <Text type="statistics-heading">Nome</Text>
                    <Text type="statistics-heading">Titolo attività</Text>
                    <Text type="statistics-heading">Presenza</Text>
                    <Text type="statistics-heading">Stato Quiz</Text>
                    <Text type="statistics-heading">Punteggio</Text>
                    <Text type="statistics-heading">Data e ora inzio quiz</Text>
                    <Text type="statistics-heading">Data e ora fine quiz</Text>
                  </Legend>
                )}
                <UserCard key={user?.id}>
                  <Text type="h3">
                    {user.name} {user?.surname}
                  </Text>
                  <Text type="b4">{user?.activity_title}</Text>
                  <Text type="b4">{user?.presence ? 'Sì' : 'No'}</Text>
                  <Text type="b4">{getFilterLabel(user?.quiz_status)}</Text>
                  <Text type="b4">
                    {Number(user?.percentage || 0).toFixed(2) * 100}%
                  </Text>
                  <Text type="b4">
                    {timestampToDate(user?.quiz_start_time, 'DD/MM/YYYY HH:mm')}
                  </Text>
                  <Text type="b4">
                    {timestampToDate(user?.quiz_end_time, 'DD/MM/YYYY HH:mm')}
                  </Text>
                </UserCard>
              </LegendAndCard>
            ))}
          </CardsWrapper>
        ) : (
          <NoResult />
        )}
      </ScrollableArea>
      <Footer>
        {pager?.number_of_pages > 1 && (
          <Pagination
            pt={0}
            pb={0}
            pager={pager}
            callBack={loadMore}
            setItemsPerPage={setItemsPerPage}
          />
        )}
      </Footer>
    </Modal>
  );
};

ModalSessionResults.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  payload: PropTypes.object,
  list: PropTypes.array,
  filters: PropTypes.object,
  pager: PropTypes.object,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getSessionResult: PropTypes.func.isRequired,
  exportSessionResult: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { payload } = state.app.modal;
      const { list, filters, pager } = state.liveEvent.sessionResult;
      return { payload, list, filters, pager };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getSessionResult: (id, filters) =>
        dispatch({ type: SESSION_RESULT_GET._REQUEST, id, filters }),
      exportSessionResult: (sessionId) =>
        dispatch({ type: SESSION_RESULT_EXPORT._REQUEST, sessionId }),
    })
  ),
  withMediaQueries
)(ModalSessionResults);
